//API request/response types

import { Link, Product, ProductOffer } from "./database-types"

export enum PaymentMethod {
    PIX = "PIX",
    CARD = "CARD",
    UNDEFINED = "UNDEFINED"
}

//-------------REQUEST AND RESPONSE


//LINK API RESPONSE TYPES
export type GetGroupsResponse = {
    groups:GroupData[]
}
export type GetMessagesResponse = {
    messages:ChatMessageData[]
}
export type CreateInviteResponse = {
    linkId:string
}
export type GetInternalLinkResponse = {
    link: Link
    productOffer?: ProductOffer
    groupMember?: boolean
    nextStep: PaymentNextStep
    paymentLink: string
    paymentMethod:PaymentMethod,
    ongoingTransactionOfferId?: string,
    missingTaxInfo:boolean
}
export type GetPublicLinkResponse = {
    link: Link
}
//STORE API RESPONSE TYPES
export type GetOfferResponse = {
    offer: ProductOffer,
    product:Product
}
export type CreateTransactionResponse = {
    paymentLink: string,
    nextAction:PurchaseNextAction,
    status:CreateTransactionStatus
}

export type CreateCheckoutResponse = {
    checkoutLink?: string;
    status: CreateCheckoutStatus;
    nextAction: PurchaseNextAction;
}

//LINK API RESPONSE TYPES
export type UploadAvatarResponse = {
    url:string
}




//-------------SUPPORTING TYPES

export type GroupData = {
    id: string;
    name: string;
    members?: {
        id: string;
        name: string;
        leader?: boolean;
    }[];
};

export type ChatMessageData = {
    id: string,
    senderId: string,
    content: string,
    dateTime: string
}

export enum CreateCheckoutStatus {
    SUCCESS = "SUCCESS",
    EXISTING_CHECKOUT = "EXISTING_CHECKOUT",
    INVALID_OFFER = "INVALID_OFFER",
    ALREADY_OWNED = "ALREADY_OWNED",
}

export enum CreateTransactionStatus {
    SUCCESS = "SUCCESS",
    ERROR_EXISTING_TRANSACTION = "ERROR_EXISTING_TRANSACTION",
    ERROR_MISSING_TAX_INFO = "ERROR_MISSING_TAX_INFO",
    ERROR_INVALID_OFFER = "ERROR_INVALID_OFFER",
    ERROR_PRODUCT_ALREADY_OWNED = "ERROR_PRODUCT_ALREADY_OWNED",
    ERROR_INVALID_PAYMENT_METHOD = "ERROR_INVALID_PAYMENT_METHOD",
}

export enum PurchaseNextAction {
    OPEN_PAYMENT_LINK = "OPEN_PAYMENT_LINK",
    REQUEST_ADDITIONAL_INFO = "REQUEST_ADDITIONAL_INFO",
    OPEN_PRODUCT = "OPEN_PRODUCT",
    NONE = "NONE",
}

export enum PaymentNextStep {
    INITIATE_PAYMENT="INITIATE_PAYMENT",
    FOLLOW_UP_ONGOING_PAYMENT="FOLLOW_UP_ONGOING_PAYMENT",
    PAYMENT_SUCCESS="PAYMENT_SUCCESS",
    ERROR="ERROR",
}

//ERROR AND REASON TYPES

export enum InviteReturnTypes {
    INVITE_ACCEPTED="INVITE_ACCEPTED",
    INVITE_CREATED="INVITE_CREATED",
    INVITE_FOUND="INVITE_FOUND",
  
    GENERIC_ERROR="GENERIC_ERROR",
  
    INVALID_USER="INVALID_USER",
    INVALID_CODE="INVALID_CODE",
  
    INVALID_GROUP="INVALID_GROUP",
    USER_ALREADY_MEMBER="USER_ALREADY_MEMBER",
    USER_DOESNT_OWN_PRODUCT="USER_DOESNT_OWN_PRODUCT",

    USER_DOESNT_OWN_GROUP="USER_DOESNT_OWN_GROUP",
    GROUP_HAS_NO_INVITE="GROUP_HAS_NO_INVITE",
    GROUP_HAS_MISSING_PRODUCT="GROUP_HAS_MISSING_PRODUCT",
}

export enum ApiErrorCode {
  UNAUTHORIZED="UNAUTHORIZED",
  GENERIC_ERROR="GENERIC_ERROR",

  PAYMENT_PROVIDER_VALIDATION_ERROR="PAYMENT_PROVIDER_VALIDATION_ERROR",
  PAYMENT_PROVIDER_ERROR="PAYMENT_PROVIDER_ERROR",


  //User, link, offer reasons
    INVALID_USER="INVALID_USER",
    INVALID_LINK="INVALID_LINK",
    INVALID_OFFER="INVALID_OFFER",

    INVALID_TAX_NR="INVALID_TAX_NR",

    //Group reasons
    INVALID_GROUP="INVALID_GROUP",
    INVALID_CHAT="INVALID_CHAT",
    INVALID_MSG_CONTENT="INVALID_MSG_CONTENT",

    USER_ALREADY_MEMBER="USER_ALREADY_MEMBER",
    USER_DOESNT_OWN_GROUP="USER_DOESNT_OWN_GROUP",
    GROUP_HAS_NO_INVITE="GROUP_HAS_NO_INVITE",
    GROUP_HAS_MISSING_PRODUCT="GROUP_HAS_MISSING_PRODUCT",

    INVALID_PRODUCT="INVALID_PRODUCT",

    //Product reasons
    USER_DOESNT_OWN_PRODUCT="USER_DOESNT_OWN_PRODUCT",

    INVALID_PAYMENT_RETURN_URL="INVALID_PAYMENT_RETURN_URL",
}

export interface BaseError {
    type: 'ApiError';
    code: ApiErrorCode;
    message: string;
    details?: any;
}

export class ApiError extends Error implements BaseError {
  public readonly type = 'ApiError' as const;
  constructor(
    public readonly code: ApiErrorCode,
    message: string,
    public readonly details?: any
  ) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
  }

  toJSON() {
    return {
      type: this.type,
      code: this.code,
      message: this.message,
      details: this.details,
    };
  }
}
